import { COMPONENT_SIMPLE_IMAGE } from '~/models/MarkupComponentNames.model';
import type { MarkupData } from '~/repository/modules/category.module';
import { useMarkupComponents } from './general/useMarkupComponents';
import type { AggregatedDiscountDto } from '~/models/ListingProduct.api.model';

export interface ImageConfigData {
  ImageUrl?: string;
  ImageAlt?: string;
  OverlayPDPSmall?: string;
  OverlayPDPMedium?: string;
  OverlayPDPLarge?: string;
  OverlayPLPSmall?: string;
  OverlayPLPMedium?: string;
  OverlayPLPLarge?: string;
  DisplayPDP?: boolean;
  DisplayPLP?: boolean;
}

export const useDiscountImage = (
  isPDP: boolean,
  discounts?: AggregatedDiscountDto[] | undefined,
) => {
  if (!discounts && isPDP) {
    const store = useMyProductPageStore();
    discounts = store.currentBundlePrice?.Discounts;
  }

  const markupData = reactive<MarkupData>({ PageContent: [] });

  watchEffect(() => {
    markupData.PageContent = discounts
      ? discounts
          .filter(
            (d) =>
              (isPDP ? d.DiscountType === 'FreeProduct' : true) &&
              Array.isArray(d.Description),
          )
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .flatMap((d) => d.Description as any)
      : [];
  });

  const { processedMarkupComponents } = useMarkupComponents(markupData);

  const discountImage = computed(() => {
    for (const data of processedMarkupComponents.value) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const checkComponent = (c: any): ImageConfigData | null => {
        if (c.Component?.toLowerCase() !== COMPONENT_SIMPLE_IMAGE) {
          return null;
        }

        return isPDP
          ? c.DisplayPLP === true
            ? (c as ImageConfigData)
            : null
          : c.DisplayPDP === true
            ? (c as ImageConfigData)
            : null;
      };

      const topLevelComponent = checkComponent(data);
      if (topLevelComponent) {
        return topLevelComponent;
      }

      if (data.innerMarkup) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nestedComponent = data.innerMarkup
          .map((c: any) => checkComponent(c))
          .find(Boolean);
        if (nestedComponent) {
          return nestedComponent;
        }
      }
    }
    return null;
  }) as ImageConfigData;

  return { discountImage };
};
